import { useState, useEffect } from 'react'

/**
 * DelayedSpinner - Only shows after a delay to prevent flash on quick loads
 */
export default function DelayedSpinner({ delay = 300, message = "Loading..." }) {
  const [show, setShow] = useState(false)

  useEffect(() => {
    const timer = setTimeout(() => setShow(true), delay)
    return () => clearTimeout(timer)
  }, [delay])

  if (!show) return null

  return (
    <div className="flex items-center justify-center min-h-[60vh]">
      <div className="text-center">
        <div className="inline-block animate-spin rounded-full h-12 w-12 border-b-2 border-ice-600 mb-4"></div>
        <p className="text-slate-600">{message}</p>
      </div>
    </div>
  )
}
